export default __webpack_public_path__ + "static/media/data-report-animate (1).10b0f908.svg";